import IndexLandingPage from "./IndexLandingPage";

export default IndexLandingPage;
